import { render, staticRenderFns } from "./resultDetailView.vue?vue&type=template&id=19819c50&scoped=true&"
import script from "./resultDetailView.vue?vue&type=script&lang=js&"
export * from "./resultDetailView.vue?vue&type=script&lang=js&"
import style0 from "./resultDetailView.vue?vue&type=style&index=0&id=19819c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19819c50",
  null
  
)

export default component.exports